"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFooterMobile = void 0;
var _uiKit = require("@cian/ui-kit");
var _button = require("@cian/ui-kit/button");
var _typography = require("@cian/ui-kit/typography");
var styles = _interopRequireWildcard(require("./styles.css"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalFooterMobile = props => {
  const {
    loading,
    title,
    submitButtonText,
    isSubmitButtonDisabled,
    onApply
  } = props;
  const showTitle = !loading && !!title;
  const showTextContentBlock = loading || showTitle;
  return /*#__PURE__*/React.createElement("footer", {
    className: styles['footer']
  }, showTextContentBlock && /*#__PURE__*/React.createElement("div", {
    className: styles['text-container']
  }, loading && /*#__PURE__*/React.createElement(_uiKit.Spinner, {
    size: 16
  }), showTitle && /*#__PURE__*/React.createElement(_typography.UIHeading5, {
    textAlign: "center"
  }, title)), /*#__PURE__*/React.createElement(_button.Button, {
    fullWidth: true,
    theme: "fill_primary",
    size: "L",
    onClick: onApply,
    disabled: isSubmitButtonDisabled
  }, submitButtonText));
};
exports.ModalFooterMobile = ModalFooterMobile;